(() => {
  if (window.barbaraInstagramConsentReady) return;
  window.barbaraInstagramConsentReady = true;
  const initialized = new WeakSet();
  let apiPromise;
  const getApi = () => {
    if (window.Shopify?.customerPrivacy?.currentVisitorConsent) {
      return Promise.resolve(window.Shopify.customerPrivacy);
    }
    if (!apiPromise) {
      apiPromise = new Promise((resolve, reject) => {
        if (!window.Shopify?.loadFeatures) {
          reject(new Error('Privacy API unavailable'));
          return;
        }
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          const api = window.Shopify.customerPrivacy;
          if (error || !api?.currentVisitorConsent) reject(error || new Error('Privacy API unavailable'));
          else resolve(api);
        });
      }).catch(error => { apiPromise = undefined; throw error; });
    }
    return apiPromise;
  };
  const init = () => {
    document.querySelectorAll('[data-bec-instagram-consent]').forEach(gate => {
      if (initialized.has(gate)) return;
      initialized.add(gate);
      const template = gate.querySelector('[data-bec-instagram-template]');
      const mount = gate.querySelector('[data-bec-instagram-mount]');
      const notice = gate.querySelector('[data-bec-instagram-notice]');
      const status = gate.querySelector('[data-bec-instagram-status]');
      if (!template || !mount || !notice || !status) return;
      let started = false;
      let reloading = false;
      const permitted = api => api.currentVisitorConsent().marketing === 'yes';
      const showError = () => { status.textContent = status.dataset.error; };
      const update = async () => {
        try {
          const api = await getApi();
          if (!gate.isConnected || reloading) return;
          if (!permitted(api)) {
            if (started) {
              reloading = true;
              mount.replaceChildren();
              mount.hidden = true;
              notice.hidden = false;
              window.location.reload();
            }
            return;
          }
          if (started) return;
          started = true;
          const fragment = document.importNode(template.content, true);
          const scripts = [...fragment.querySelectorAll('script')];
          mount.appendChild(fragment);
          mount.hidden = false;
          notice.hidden = true;
          for (const original of scripts) {
            if (!permitted(api)) {
              reloading = true;
              mount.replaceChildren();
              window.location.reload();
              return;
            }
            const executable = document.createElement('script');
            for (const attribute of original.attributes) executable.setAttribute(attribute.name, attribute.value);
            executable.textContent = original.textContent;
            if (original.src) {
              executable.async = false;
              await new Promise((resolve, reject) => {
                executable.onload = resolve;
                executable.onerror = reject;
                original.replaceWith(executable);
              });
            } else original.replaceWith(executable);
          }
        } catch {
          showError();
          notice.hidden = false;
        }
      };
      document.addEventListener('visitorConsentCollected', update);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
